/**
 * 显隐动画
 */
import fvAnimation from "./fvAnimation"
export default class fvHide extends fvAnimation {
    constructor(shape){
        super(shape,"fvHide");
        this.sizeFunction = AsyncFunction("return " + this.expression);
    }

    async run(canvas,value){
        if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        // 闪烁显隐下为true，不执行后面逻辑
        if(this.shape.animation.fvTwinkel && this.shape.animation.fvTwinkel.model == "v"){
            let twinkelSize = await this.executionScript(AsyncFunction("return " + this.shape.animation.fvTwinkel.expression));
            if(twinkelSize){
                return;
            }
        }
        // 表达式已取反不需要判断condition
        this.shape.Show(size,canvas);
    }
}


// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvHide.js